import { defineMessages } from 'react-intl'

export default defineMessages({
  previous: {
    id: 'containers.SupplierProfile.controls.previous',
    defaultMessage: 'Previous',
  },
  next: {
    id: 'containers.SupplierProfile.controls.next',
    defaultMessage: 'Next',
  },
  complete: {
    id: 'containers.SupplierProfile.controls.complete',
    defaultMessage: 'Complete',
  },
  progress: {
    id: 'containers.SupplierProfile.controls.progress',
    defaultMessage: '{x} of {y}',
  },
  save: {
    id: 'containers.SupplierProfile.save',
    defaultMessage: 'Save',
  },
  saveAndReturn: {
    id: 'containers.SupplierProfile.saveAndReturn',
    defaultMessage: 'Save and return to dashboard',
  },
  help: {
    id: 'containers.SupplierProfile.help',
    defaultMessage: 'Help',
  },
  loading: {
    id: 'containers.SupplierProfile.loading',
    defaultMessage: 'Loading',
  },
  inaccessible: {
    id: 'containers.SupplierProfile.inaccessible',
    defaultMessage: 'You are trying to access a step that is not yet available. Please go back to the previous step.',
  },
  basics: {
    id: 'containers.supplierprofile.routes.basics',
    defaultMessage: 'Basic info',
  },
  basicsHint: {
    id: 'containers.supplierprofile.routes.basics.hint',
    defaultMessage: ' ',
  },
  collaborationAndNda: {
    id: 'containers.SupplierProfile.routes.collaborationAndNda',
    defaultMessage: 'Collboration and NDA',
  },
  collaborationAndNdaHint: {
    id: 'containers.SupplierProfile.routes.collaborationAndNda.hint',
    defaultMessage: ' ',
  },
  yourVoice: {
    id: 'containers.SupplierProfile.routes.yourVoice',
    defaultMessage: 'Your voice',
  },
  yourVoiceHint: {
    id: 'containers.SupplierProfile.routes.yourVoice.hint',
    defaultMessage: ' ',
  },
  skillsAndSetup: {
    id: 'containers.SupplierProfile.routes.skillsAndSetup',
    defaultMessage: 'Skills and setup',
  },
  skillsAndSetupHint: {
    id: 'containers.SupplierProfile.routes.skillsAndSetup.hint',
    defaultMessage: ' ',
  },
  settingTheScene: {
    id: 'containers.SupplierProfile.routes.settingTheScene',
    defaultMessage: 'Setting the scene',
  },
  settingTheSceneHint: {
    id: 'containers.SupplierProfile.routes.settingTheScene.hint',
    defaultMessage: 'We work closely together with our talents and like to see you as more than a voice in our voicebank.\nBy uploading a photo and telling us about yourself, you\'re helping our team put the voice and the person together.',
  },
  demos: {
    id: 'containers.supplierprofile.routes.demos',
    defaultMessage: 'Demos',
  },
  demosHint: {
    id: 'containers.supplierprofile.routes.demos.hint',
    defaultMessage: ' ',
  },
  review: {
    id: 'containers.supplierprofile.routes.review',
    defaultMessage: 'Review',
  },
  reviewHint: {
    id: 'containers.supplierprofile.routes.review.hint',
    defaultMessage: ' ',
  },
  rates: {
    id: 'containers.supplierprofile.routes.rates',
    defaultMessage: 'Rates',
  },
  ratesHint: {
    id: 'containers.supplierprofile.routes.rates.hint',
    defaultMessage: ' ',
  },
  paymentBanking: {
    id: 'containers.supplierprofile.routes.paymentBanking',
    defaultMessage: 'Payment and banking',
  },
  paymentBankingHint: {
    id: 'containers.supplierprofile.routes.paymentBanking.hint',
    defaultMessage: ' ',
  },
  availability: {
    id: 'containers.supplierprofile.routes.availability',
    defaultMessage: 'Availability',
  },
  availabilityHint: {
    id: 'containers.supplierprofile.routes.availability.hint',
    defaultMessage: ' ',
  },
  logoSrc: {
    id: 'containers.supplierprofile.logoSrc',
    defaultMessage: 'https://voicearchive-branding.s3.eu-central-1.amazonaws.com/favicon-black.png',
  },
  helpEmail: {
    id: 'containers.supplierprofile.helpEmail',
    defaultMessage: 'studio@voicearchive.com',
  },
})
